<template>
	<div data-app class="right-memo-box q-detail">
		<PageHeader>
			<div>
				<button
					type="button"
					class="btn mint q-detail__header-btn"
					v-text="'AI 분석요청'"
					@click="analysisAI"
				/>
				<button
					type="button"
					class="btn blue q-detail__header-btn"
					v-text="'답변 등록'"
					@click="registerReply"
				/>
				<button
					v-if="qna.isOfficial"
					type="button"
					class="btn red q-detail__header-btn"
					v-text="'질문 삭제'"
					@click="deleteQna"
				/>
			</div>
		</PageHeader>
		<form @submit.prevent="submitData">
			<ManagingSection :columnCount="2">
				<ManagingBox title="질문번호">{{ qna.id }}</ManagingBox>
				<ManagingBox title="등록일">{{ registerDate }}</ManagingBox>
				<ManagingBox title="작성자">
					<template v-if="qna.isOfficial">관리자</template>
					<RouterLink
						v-else
						:to="`/register/register-info/${qna.register.idRegister}`"
						target="_blank"
						class="link"
						v-text="qna.register.nickName"
					/>
				</ManagingBox>
				<ManagingBox title="신고건">
					<RouterLink
						:to="`/qna/q/report/list?target=qnaId&value=${qId}`"
						target="_blank"
						class="link"
						v-text="qna.reportCount"
					/>
				</ManagingBox>
			</ManagingSection>
			<ManagingSection v-if="qna.isOfficial" :splice="true">
				<ManagingBox title="브랜드">
					<SearchBrand
						ref="searchBrand"
						searcherPlaceholder="브랜드명를 입력하세요"
						selectedPlaceholder="브랜드를 선택해 주세요"
						:useLastBrand="false"
						:showIfIsDisplay="true"
						@change="idBrandChange"
					/>
				</ManagingBox>
			</ManagingSection>
			<ManagingSection :columnCount="2" :splice="true">
				<ManagingBox title="답변">
					<button
						type="button"
						:class="{ link: qna.replyCount > 0 }"
						v-text="qna.replyCount"
						@click="checkAnswerNumber(qna.replyCount, qId)"
					/>
				</ManagingBox>
				<ManagingBox title="좋아요">{{ qna.likeCount }}</ManagingBox>
				<ManagingBox title="질문고정">
					<RadioList v-model="qna.isFixed" :radioList="fixedState" />
				</ManagingBox>
				<ManagingBox title="상태">
					<RadioList
						v-model="qna.state"
						:disabledIds="
							qna.isOfficial ? ['정상', '차단', '검수'] : ['검수']
						"
						:disabled="true"
						:radioList="stateList"
					/>
				</ManagingBox>
			</ManagingSection>
			<ManagingSection :splice="true">
				<ManagingBox
					v-if="qna.state == '차단'"
					title="차단사유"
					:horizontalMode="true"
					contsClass="q-detail__static-code-wrapper"
				>
					<Selector
						v-model="selectedStaticCode1"
						:optionList="staticCodes"
						valueKey="code"
					/>
					<Selector
						v-model="selectedStaticCode2"
						:optionList="staticCodes"
						valueKey="code"
					/>
					<p
						v-if="!selectedStaticCode1"
						class="q-detail__static-code-err"
						v-text="'첫번째 사유는 필수로 선택해야 합니다!'"
					/>
				</ManagingBox>
				<ManagingBox title="질문분야">
					<CategorySelector
						v-for="(_, i) in qna.categoryList"
						:key="i"
						:disabled="false"
						:category_level="2"
						ref="categorySelector"
						@change="onChangeCategory"
					/>
				</ManagingBox>
				<ManagingBox title="제목">
					<input
						v-model="qna.title"
						:disabled="!qna.isOfficial"
						class="input"
					/>
				</ManagingBox>
				<ManagingBox title="내용">
					<textarea v-model="qna.text" :disabled="!qna.isOfficial" />
				</ManagingBox>
				<ManagingBox title="브랜드 태그">
					<div>
						<BrandSelector
							ref="brandSelector"
							:exceptBrandIds="brandIdList"
							:disabled="5 <= qna.brandList.length"
							@change="onChangeBrand"
						/>
						<button
							:disabled="
								!selectedBrand || 5 <= qna.brandList.length
							"
							class="btn"
							v-text="'추가'"
							@click="addBrand"
						/>
					</div>
					<ul class="brand-tag">
						<li
							v-for="row in qna.brandList"
							:key="row.brand.idBrand"
						>
							<span class="qna-register__brand-name">{{
								row.brand.name
							}}</span>
							<button
								type="button"
								class="btn-remove btn-remove-black"
								@click="removeBrand(row.brand.idBrand)"
							>
								<i class="fa fa-times-circle" />
							</button>
						</li>
					</ul>
				</ManagingBox>
				<ManagingBox title="사진첨부">
					<ImgListSelector
						v-if="qna.isOfficial"
						:useLink="false"
						:value="imageUrlList"
						@input="imageListChange"
					/>
					<div v-else class="q-detail__attached-img-wrapper">
						<div
							v-for="img in qna.doc.qna_image"
							:key="img.key"
							class="q-detail__attached-img"
						>
							<button
								type="button"
								class="btn-remove remove_icon"
								@click="removeImage(img.key)"
							>
								<i class="fa fa-times-circle" />
							</button>
							<Thumbnail
								:src="`${env.IMAGE_STORAGE_PATH}/${img.key}`"
								:height="100"
							/>
							<p
								v-if="img.state === '부적합'"
								class="q-detail__invalid-img"
								v-text="img.state"
							/>
						</div>
					</div>
				</ManagingBox>
				<ManagingBox title="연관제품">
					<ProductSearcher2 @change="onSelectProduct" />
					<table class="simple-table q-detail__pdt-table">
						<thead>
							<tr>
								<th>제품항번</th>
								<th>이미지</th>
								<th>브랜드명</th>
								<th>제품명</th>
								<th>노출</th>
								<th>단종</th>
								<th>제거</th>
							</tr>
						</thead>
						<tbody v-if="qna.productList.length">
							<tr
								v-for="row in qna.productList"
								:key="row.productId"
							>
								<td>{{ row.productId }}</td>
								<td>
									<img :src="row.imageUrl" />
								</td>
								<td>{{ row.brand.brandTitle }}</td>
								<td>{{ row.productTitle }}</td>
								<td :class="row.isDisplay ? '' : 'font-red'">
									{{ row.isDisplay ? '노출' : '미노출' }}
								</td>
								<td
									:class="row.isDiscontinue ? 'font-red' : ''"
								>
									{{ row.isDiscontinue ? '단종' : '정상' }}
								</td>
								<td>
									<button
										type="button"
										class="btn-minus"
										@click="removeProduct(row.productId)"
									>
										<i class="fa fas fa-minus" />
									</button>
								</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td colspan="7">등록된 제품이 없습니다.</td>
							</tr>
						</tbody>
					</table>
				</ManagingBox>
				<ManagingBox title="AI답변 내용">{{
					qnaAiLog.content
				}}</ManagingBox>
				<ManagingBox title="AI답변 노출여부">
					<RadioList
						v-if="hasAi"
						v-model="qnaAiLog.isDisplay"
						:radioList="isAiDisplayList"
					/>
				</ManagingBox>
				<ManagingBox title="AI답변 반응">
					<p v-if="hasAi">
						<span class="color-green"
							>좋아요 {{ qnaAiLog.likeCount | number }}</span
						>
						/
						<span class="font-red"
							>아쉬워요 {{ qnaAiLog.disLikeCount | number }}</span
						>
					</p>
				</ManagingBox>
			</ManagingSection>
			<div class="btn-wrap-main">
				<button
					type="button"
					class="btn-main"
					v-text="'취소'"
					@click="$router.go(-1)"
				/>
				<button
					:disabled="disableSubmit"
					type="submit"
					class="btn-main blue"
					v-text="'수정'"
				/>
			</div>
		</form>
		<RightMemoBox refType="qna" :refId="qId" />
	</div>
</template>
<script>
	import compact from 'lodash/compact';
	import reject from 'lodash/reject';
	import find from 'lodash/find';
	import moment from 'moment';
	import { mapState } from 'vuex';
	import { getS3Url, uploadS3, imageRemove } from '@/util.js';
	import PageHeader from '@/components/PageHeader.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import SearchBrand from '@/components/SearchBrand.vue';
	import RadioList from '@/components/RadioList.vue';
	import Selector from '@/components/Selector.vue';
	import CategorySelector from '@/components/common/CategorySelector.vue';
	import BrandSelector from '@/components/common/BrandSelector.vue';
	import ImgListSelector from '@/components/ImgListSelector.vue';
	import Thumbnail from '@/components/Thumbnail.vue';
	import ProductSearcher2 from '@/components/ProductSearcher2.vue';
	import RightMemoBox from '@/components/RightMemoBox.vue';

	export default {
		name: 'QnaQDetail',
		components: {
			PageHeader,
			ManagingSection,
			ManagingBox,
			SearchBrand,
			RadioList,
			Selector,
			CategorySelector,
			BrandSelector,
			ImgListSelector,
			Thumbnail,
			ProductSearcher2,
			RightMemoBox,
		},
		data() {
			return {
				qId: Number(this.$route.params._id),
				selectedBrand: undefined,
				selectedStaticCode1: null,
				selectedStaticCode2: null,
				qnaCategoryId: undefined,
				deleteImageKeys: [], // 삭제할 첨부 이미지 key 배열
				qna: {
					register: {},
					id: parseInt(this.$route.params._id),
					categoryList: [],
					brandList: [],
					productList: [],
					doc: {},
					likeCount: 0,
					replyCount: 0,
					isFixed: false,
					title: '',
					text: '',
				},
				registerDate: '',
				officialRefId: '',
				stateList: [
					{ id: '정상', value: '정상' },
					{ id: '차단', value: '차단' },
					{ id: '검수', value: '검수' },
				],
				fixedState: [
					{ id: true, value: 'Y' },
					{ id: false, value: 'N' },
				],
				isAiDisplayList: [
					{ id: true, value: '노출' },
					{ id: false, value: '미노출' },
				],
				imageUrlList: [],
				officialImageKey: [],
				qnaAiLog: {},
			};
		},
		computed: {
			...mapState({
				staticCodes: state =>
					state.filter.staticCodes.filter(
						item => item.parent_code === 'QNA_BLOCK'
					),
				maxProductLength: state => state.qna.maxAttachProductLength,
			}),
			brandIdList() {
				return this.qna.brandList.map(({ brand }) => brand.idBrand);
			},
			hasAi() {
				return this.qnaAiLog.id;
			},
			disableSubmit() {
				return this.qna.state === '차단' && !this.selectedStaticCode1;
			},
		},
		mounted() {
			this.initData();
		},
		methods: {
			async initData() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/qna/${this.qId}`
					);

					this.qna = {
						...data,
						doc: data.doc && JSON.parse(data.doc),
					};
					this.selectedStaticCode1 =
						this.qna.staticCodeList[0]?.code || null;
					this.selectedStaticCode2 =
						this.qna.staticCodeList[1]?.code || null;
					this.registerDate = moment(this.qna.createdAt).format(
						'YYYY-MM-DD HH:mm:ss'
					);
					this.officialRefId = this.qna.officialRefId;
					this.imageUrlList = this.qna.doc.qna_image.map(item => ({
						src: `${this.env.IMAGE_STORAGE_PATH}/${item.key}`,
					}));
					this.qnaAiLog = this.qna.qnaAiLog || {};

					await this.$nextTick();

					if (this.qna.isOfficial) {
						this.$refs.searchBrand.setBrand(
							this.qna.officialRefId,
							this.qna.officialBrand.brandTitle
						);
					}

					for (const [
						i,
						category,
					] of this.qna.categoryList.entries()) {
						await this.$refs.categorySelector[i].setCategory({
							category1: category.firstCategory.idFirstCategory,
							category2: category.secondCategory.idSecondCategory,
						});
					}
				} catch (err) {
					console.error(err);
					alert('데이터를 불러오는데 실패했습니다.');
				}
			},
			async analysisAI() {
				try {
					if (!confirm('AI 분석을 요청하시겠습니까?')) return;
					await this.$axiosGpt.get(`/public/gpt/qna/${this.qId}`);
					alert('AI 분석 요청이 완료되었습니다.');
					this.initData();
				} catch (err) {
					if (err.response?.data.statusCode === 400) {
						alert(
							'gpt 분석에 실패했습니다. 1~2분뒤 재요청해주세요. 여러번 재요청해도 문제되면 백엔드개발팀에게 문의해주세요'
						);
					} else {
						alert(
							'AI 분석 요청에 실패하였습니다. 백엔드 개발팀에 문의해주세요.'
						);
					}
					console.error(err);
				}
			},
			registerReply() {
				this.$router.push(`/qna/q/${this.qId}/a`);
			},
			async deleteQna() {
				try {
					if (!confirm('질문을 삭제하시겠습니까?')) return;
					await this.$axiosAdmin2.delete(`/api/qna/${this.qId}`);
					alert('삭제되었습니다.');
					this.$router.push('/qna/q/list');
				} catch (err) {
					alert(
						'삭제에 실패하였습니다. 지속적인 문제 발생시 개발팀에 문의주세요.'
					);
					console.error(err);
				}
			},
			validation() {
				if (this.qna.isOfficial) {
					if (!this.officialRefId) {
						alert(
							'관리자가 작성한 질문은 브랜드 입력이 필수값입니다'
						);
						return false;
					}
					if (this.qna.title.length === 0) {
						alert('제목을 입력해주세요');
						return false;
					}
					if (this.qna.title && this.qna.title.trim().length < 5) {
						alert('제목은 최소 5글자 이상입니다');
						return false;
					}
					if (!this.qna.text) {
						alert('내용을 입력해주세요');
						return false;
					}
				}
				return true;
			},
			async getUploadedImgItem(src) {
				try {
					if (
						typeof src === 'object' &&
						src.hasOwnProperty('extension')
					) {
						const { data } = await getS3Url(
							src.extension,
							'qna-register'
						);
						await uploadS3(data, src.fileObject);
						src = `${data.fields.key}`;
					} else {
						src = src.src.replace(
							`${this.env.IMAGE_STORAGE_PATH}/`,
							''
						);
					}
					return { src };
				} catch (err) {
					console.error(err);
				}
			},
			async uploadAllImages(imgList) {
				try {
					return await Promise.all(
						imgList.map(async image => {
							const update = await this.getUploadedImgItem(image);
							if (!update) {
								alert('이미지 등록에 실패하였습니다.');
								throw new Error(error);
							}
							return update.src;
						})
					);
				} catch (err) {
					console.error(err);
					alert('이미지 등록에 실패하였습니다.');
					throw new Error(err);
				}
			},
			async getParams() {
				const uploadeImage = await this.uploadAllImages(
					this.imageUrlList
				);
				const doc = this.qna.doc;
				const params = {
					categoryIdList: this.qnaCategoryId,
					brandIdList: this.brandIdList,
					productIdList: this.qna.productList.map(
						item => item.productId
					),
					isFixed: this.qna.isFixed,
				};

				if (this.qna.isOfficial) {
					params.title = this.qna.title;
					params.text = this.qna.text;
					params.officialRefId = this.officialRefId;
					params.doc = JSON.stringify({
						...doc,
						qna_image: uploadeImage.map(key => ({
							bucket: 'glowpick',
							state: '정상',
							key,
						})),
					});
				} else {
					params.updateState = { state: this.qna.state };
					if (this.qna.state === '정상' && doc) {
						params.doc = JSON.stringify({
							...doc,
							qna_image: doc?.qna_image?.map(imageInfo => ({
								...imageInfo,
								state: '정상',
							})),
						});
					} else if (this.qna.state === '차단') {
						params.updateState.staticCodeList = compact([
							this.selectedStaticCode1,
							this.selectedStaticCode2,
						]).map(row => ({ code: row }));
					}
				}

				if (this.hasAi) {
					params.isAiDisplay = this.qnaAiLog.isDisplay;
				}

				return params;
			},
			async submitData() {
				try {
					if (!this.validation()) return;
					const params = await this.getParams();
					await this.$axiosAdmin2.put(`/api/qna/${this.qId}`, params);
					await imageRemove(this.deleteImageKeys);
					this.$router.go(-1);
				} catch (err) {
					if (err.response.data?.message) {
						alert(
							err.response.data?.message ??
								'수정을 실패하였습니다.'
						);
					} else {
						alert('수정을 실패하였습니다.');
					}
				}
			},
			idBrandChange(changes) {
				this.officialRefId = changes.idBrand;
			},
			checkAnswerNumber(answerNumber, answerId) {
				if (answerNumber <= 0) return;
				const routeData = this.$router.resolve({
					path: '/qna/a/list',
					query: { answerName: 'qnaId', qnaId: answerId },
				});
				window.open(routeData.href, '_blank');
			},
			onChangeCategory(obj) {
				this.qnaCategoryId = [obj.category2];
			},
			onChangeBrand(obj) {
				this.selectedBrand = obj;
			},
			addBrand() {
				this.qna.brandList.push({ brand: { ...this.selectedBrand } });
				this.$refs.brandSelector.init();
			},
			removeBrand(idBrand) {
				this.qna.brandList = reject(this.qna.brandList, {
					brand: { idBrand },
				});
			},
			imageListChange(imageList) {
				this.imageUrlList = imageList;
			},
			removeImage(key) {
				this.deleteImageKeys.push(key);
				this.qna.doc.qna_image = reject(this.qna.doc.qna_image, {
					key,
				});
			},
			onSelectProduct(item) {
				if (
					find(this.qna.productList, { productId: item.idProduct }) ||
					this.maxProductLength <= this.qna.productList.length
				)
					return;

				this.qna.productList.push({
					productId: item.idProduct,
					productTitle: item.productTitle,
					brand: { brandTitle: item.brandTitle },
					imageUrl: item.filePath,
					isDiscontinue: item.isDiscontinue ? 1 : 0,
					isDisplay: item.isDisplay ? 1 : 0,
					temp: true,
				});
			},
			removeProduct(productId) {
				this.qna.productList = reject(this.qna.productList, {
					productId,
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.q-detail {
		&__header-btn {
			margin-left: 8px;

			&:first-child {
				margin-left: 0;
			}
		}

		&::v-deep .q-detail__static-code-wrapper {
			flex-wrap: wrap;
		}

		&__static-code-err {
			width: 100%;
			color: $red;
		}

		&__attached-img-wrapper {
			display: flex;
		}

		&__attached-img {
			position: relative;
			margin-right: 8px;

			.remove_icon {
				position: absolute;
				top: -9px;
				right: -9px;
				z-index: 100;

				.fa-times-circle {
					font-size: 20px;
				}
			}
		}

		&__invalid-img {
			width: 100%;
			background: $red;
			line-height: 26px;
			color: white;
			text-align: center;
		}

		&__pdt-table {
			margin-top: 8px;
			table-layout: fixed;

			thead {
				tr {
					height: 40px;
				}

				th {
					padding: 6px 0;
					text-align: center;

					&:nth-child(1),
					&:nth-child(2) {
						width: 70px;
					}

					&:nth-child(3) {
						width: 140px;
					}

					&:nth-child(4) {
						width: auto;
					}

					&:nth-child(5),
					&:nth-child(6),
					&:nth-child(7) {
						width: 50px;
					}
				}
			}

			tbody {
				td {
					width: auto;
					text-align: center;
					padding: 6px;
				}
			}
		}
	}

	.brand-tag {
		display: flex;
		align-items: center;
		gap: 10px;
		margin-top: 15px;
		padding: 0;

		li {
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 6px;
			border: 1px solid #acaeb4;
			padding: 4px 9px;
			border-radius: 11px;
			font-size: 11px;
			line-height: 22px;
			cursor: default;

			&:hover {
				background-color: #ecf2f8;
			}
		}
	}
</style>
